import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KlarTilGodkendelseViewModel } from '../../store/models';
import { SagerTilGodkendelseService } from './sager-til-godkendelse.service';

@Component({
    selector: 'app-sager-til-godkendelse',
    templateUrl: './sager-til-godkendelse.component.html',
    standalone: false
})
export class SagerTilGodkendelseComponent {
    sagerTilGodkendelse$ = this.sagerTilGodkendelseService.getSagerTilGodkendelseView();

    constructor(
        private sagerTilGodkendelseService: SagerTilGodkendelseService,
        private router: Router,
        private modal: NgbActiveModal
    ) {
    }

    onClose() {
        this.modal.close();
    }

    async onGotoGodkendelse(item: KlarTilGodkendelseViewModel) {
        await this.router.navigate(['/clients', item.kid, 'udfoer', 'regnskabsaar', item.regnskabsaarId, 'sag', item.sagId]);
        this.modal.close();
    }
}
